import React, { useEffect } from "react";
import * as Yup from "yup";
import { useState } from "react";
// form
import { useForm } from "react-hook-form";
import { getGroups } from "../../../utils";

import { yupResolver } from "@hookform/resolvers/yup";
// @mui
import {
  Stack,
  Typography,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  Box,
  FormControl,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Autocomplete,
  Chip,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { FormProvider, RHFTextField } from "../../../components/hook-form";

import { useTheme } from "@mui/material/styles";

import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import Page from "../../../components/Page";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TagsInput } from "react-tag-input-component";
import "./style.css";
import { getFileUrl } from "../../../utils/firebaseUtils";
import RHFTextEditor from "../../../components/hook-form/RHFTextEditor";
const token = localStorage.getItem("token");
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const materialsOptions = [
  { id: "live", name: "Live" },
  // { id: "recorded", name: "Recorded" },
  { id: "notes", name: "Notes" },
  { id: "audio", name: "Audio" },
  { id: "video", name: "Video" },
];

function getStyles(name, teacher, theme) {
  return {
    fontWeight:
      teacher.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const sanitizeTagList = (names = []) =>
  Array.from(
    new Set(
      (names || [])
        .map((name) => String(name || "").trim())
        .filter((name) => name.length > 0)
    )
  );

const UpdateBatchDetails = () => {
  const [users, usersSet] = useState([]);
  const [subject, setSubject] = useState([]);
  const [allteachers, teacherSet] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subjectList, setsubjectList] = useState([]);
  const [materialsList, setMaterialsList] = useState([]);
  const [audioUrl, setAudioUrl] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [notesUrl, setNotesUrl] = useState("");

  const selectedMaterialIds = React.useMemo(() => {
    return materialsList
      .map((mat) => {
        if (typeof mat === "string" || typeof mat === "number") {
          return String(mat).toLowerCase();
        }
        if (mat && typeof mat === "object") {
          const rawId = mat.id ?? mat.material_id;
          return rawId ? String(rawId).toLowerCase() : "";
        }
        return "";
      })
      .filter((id) => id);
  }, [materialsList]);

  const showAudioField = selectedMaterialIds.includes("audio");
  const showVideoField = selectedMaterialIds.includes("video");
  const showNotesField = selectedMaterialIds.includes("notes");
  const showLiveField = selectedMaterialIds.includes("live");

  // upload handlers for audio and notes using firebase helper
  const handleAudioUpload = async (event) => {
    const file = event.target?.files?.[0];
    if (!file) return;
    try {
      setLoading(true);
      const uploadedUrl = await getFileUrl(file);
      setAudioUrl(uploadedUrl);
    } catch (err) {
      console.error("Audio upload failed", err);
      toast.error("Audio upload failed");
    } finally {
      setLoading(false);
    }
  };

  const handleNotesUpload = async (event) => {
    const file = event.target?.files?.[0];
    if (!file) return;
    try {
      setLoading(true);
      const uploadedUrl = await getFileUrl(file);
      setNotesUrl(uploadedUrl);
    } catch (err) {
      console.error("Notes upload failed", err);
      toast.error("Notes upload failed");
    } finally {
      setLoading(false);
    }
  };

  const [type, setType] = useState(true);
  const [teacher, setteacher] = useState([]);
  const [selected, setSelected] = useState([]);
  const [languages, setLanguages] = useState([]);

  const [url, setUrl] = useState("");

  const [selectedCategory, setSelectedCategory] = useState();
  const [subCategories, setSubCategories] = useState([]);

  // combo
  const [combo, setCombo] = useState([]);
  const [comboChecked, setComboChecked] = useState("false");
  const [testSeriesOptions, setTestSeriesOptions] = useState([]);
  const [loadingTestSeries, setLoadingTestSeries] = useState(false);
  const [testSeriesValue, setTestSeriesValue] = useState("");
  const [exam_groups_id, setExamGroupsId] = useState("");

  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [states, setStates] = useState();
  const [boards, setBoards] = useState();
  const [classVal, setClass] = useState(null);
  const [centralExam, setCentralExam] = useState(null);
  const [stateExam, setStateExam] = useState(null);
  const [category, setCategory] = useState();
  const [registrationEndDate, setRegistrationEndDate] = useState();
  const [groups, setGroups] = useState([]);

  const [parameter, setParameter] = useState({
    class_id: " ",
    exam_id: " ",
    course: " ",
  });

  const navigate = useNavigate();
  const { batchId } = useParams();
  const theme = useTheme();
  const LoginSchema = Yup.object().shape({});
  // //console.log(subjectList)
  const defaultValues = {
    batch_name: "",
    category: "",
    exam_type: "",
    subject: "",
    // teacherEmail: '',
    starting_date: "",
    ending_date: "",
    mode: "",
    materials: "",
    discount: "",
    charges: "",
    description: "",
    // banner: '',
    language: "",
    remark: "",
    validity: "",
    // course_review: '',
    remember: true,
    is_active: "true",
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = methods;
  const [file, setFile] = useState("");
  const [demoVideo, setDemoVideo] = useState([]);

  const changeHandler = async (event) => {
    const url = await getFileUrl(event.target?.files[0]);
    setUrl(url);
    console.log("File URL : ", file);
  };

  const changeHandlerTwo = async (event) => {
    setDemoVideo(event.target?.files);
  };

  //Getting Batch Details
  // let arr = [];
  const [batchDetails, setBatchDetails] = useState();
  const [tags, setTags] = useState([]);
  const [tagNames, setTagNames] = useState([]);
  const changeGroupHandler = (e) => {
    setExamGroupsId(e.target.value);
  };
  console.log("Id ", exam_groups_id);
  async function fetchTags() {
    const fullResponse = await fetch(
      `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-tags?course_id=${batchId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const responseJson = await fullResponse.json();
    console.log("Tag ", responseJson?.data);
    console.log("Tags loaded from API:", responseJson?.data?.map(tag => tag.name));
    const apiTags = responseJson?.data || [];
    setTags(apiTags);

    const activeNamesFromApi = sanitizeTagList(
      apiTags
        .filter((tag) => Number(tag.active) === 1)
        .map((tag) => tag.name)
    );

    if (activeNamesFromApi.length) {
      setTagNames((prev) =>
        Array.isArray(prev) && prev.length ? sanitizeTagList(prev) : activeNamesFromApi
      );
    }
  }

  useEffect(() => {
    let token = localStorage.getItem("token");

    async function fetchUsers() {
      const data = await getGroups();
      setGroups(data);
      const fullResponse = await fetch(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-course-by-id/${batchId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const responseJson = await fullResponse.json();
      console.log(responseJson?.data);
      setBatchDetails(responseJson?.data);
      checkDetails(responseJson?.data);
      setExamGroupsId(responseJson?.data?.course?.exam_groups_id);
      setIsActive(responseJson?.data?.course?.is_active);
      setsubjectList(responseJson?.data?.subjects.map((sub) => sub.id));
      setteacher(responseJson?.data?.teachers?.map((teacher) => teacher.id));
      setSelected(responseJson?.data?.course?.demoVideo);

      // Handle materials as array
      if (responseJson?.data?.course?.materials) {
        const materialsArray = Array.isArray(responseJson.data.course.materials) 
          ? responseJson.data.course.materials 
          : [responseJson.data.course.materials];
        setMaterialsList(materialsArray.map(mat => ({ id: mat, name: mat.charAt(0).toUpperCase() + mat.slice(1) })));
      }

      // Load URL fields from existing data
      setAudioUrl(responseJson?.data?.course?.audioUrl || '');
      setVideoUrl(responseJson?.data?.course?.videoUrl || '');
      setNotesUrl(responseJson?.data?.course?.notesUrl || '');

      // Load existing tags - only show tags with status: true as selected
      if (responseJson?.data?.course?.tags) {
        const existingTags = Array.isArray(responseJson.data.course.tags)
          ? responseJson.data.course.tags
          : [responseJson.data.course.tags];
        const tagNamesArray = sanitizeTagList(
          existingTags
            .filter((tag) => Number(tag.active) === 1) // Only include active tags
            .map((tag) => tag.name || tag)
        );
        console.log("Existing tags loaded (active === 1 only):", tagNamesArray);
        if (tagNamesArray.length) {
          setTagNames(tagNamesArray);
        }
      }

      setCategory(responseJson.data?.course?.course);
      // setSubCategories(responseJson.data?.course?.subCategory);
      setStates(responseJson.data?.course?.state_exam_name);
      setStateExam(responseJson.data?.course?.exam_name);
      setBoards(responseJson.data?.course?.boards_name);
      setClass(responseJson.data?.course?.classes_name);
      setParameter({
        ...parameter,
        exam_id: responseJson.data?.course?.exam_id,
        class_id: responseJson.data?.course?.class_id,
        course: responseJson.data?.course?.course,
      });
      setUrl(responseJson.data?.course?.course_banner);
      // setRegistrationEndDate(responseJson.data?.course?.registration_end_date);
      if (responseJson?.data?.course?.testseries_id) {
        setComboChecked("true");
        setTestSeriesValue(responseJson?.data?.course?.testseries_id);
      }
    }

    fetchUsers();
    fetchTags();
  }, []);

  const fetchLanguages = async () => {
    const token = localStorage.getItem("token");
    try {
      const languageData = await axios.post(
        `${process.env.REACT_APP_LIVE_URL_NEW}/mobile/user/get-mediums`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (languageData?.status !== 200)
        throw new Error("Failed to fetch languages");

      setLanguages(languageData?.data?.data);
    } catch (error) {
      console.error("Error fetching languages:", error);
    }
  };

  // Fetch languages when the component mounts
  useEffect(() => {
    fetchLanguages();
  }, []);

  // //console.log(batchDetails)
  // //console.log(batchDetails?.demoVideo)
  const [fileSelected, setFileSelected] = useState([]);

  const [is_active, setIsActive] = useState();
  //multipple Links Update
  // //console.log(subjectList)
  const [value, setValue] = useState();
  const checkDetails = (batchDetails) => {
    // if (batchDetails?.demoVideo[0]?.DemoVideofileType == "link") {
    //   setType(true);
    // } else {
    //   setType(false);
    // }

    let arr4 = [];
    batchDetails?.demoVideo?.map((i, indx) => arr4.push(i));

    setFileSelected(arr4);
    setIsActive(batchDetails?.is_active);

    setValue((prev) => ({
      ...prev,
      ...batchDetails?.course,
      combo: Boolean(batchDetails?.course?.combo),
    }));
    // batchDetails?.demoVideo?.map((i, indx) => helperArray.push(i))
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    async function fetchUsers() {
      const fullResponse = await fetch(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-all-admin`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const responseJson = await fullResponse.json();
      teacherSet(responseJson?.data);
      setLoading(false);
    }

    fetchUsers();
  }, []);

  //Getting category
  //Stream
  useEffect(() => {
    const token = localStorage.getItem("token");
    const batch = "Batch";
    async function fetchUsers() {
      setLoading(false);
      const res = await fetch(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/classroom-subjects`,
        {
          method: "GET",
          headers: {
            // "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const resSubject = await res.json();
      setSubject(resSubject.data);
      console.log(resSubject?.data);
      setLoading(false);
    }

    fetchUsers();
  }, []);

  const handleCategoryChange = async (event) => {
    const selectedCategoryId = event.target.value;
    console.log(event.target.value);
    setSelectedCategory(selectedCategoryId);

    // Fetch subcategories based on the selected category
    const token = localStorage.getItem("token");
    // const response = await fetch(
    //   `${process.env.REACT_APP_LIVE_URL}/adminPanel/get-subcategory/${selectedCategoryId}`,
    //   {
    //     method: "GET",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //     },
    //   }
    // );
    // const data = await response.json();
    // setSubCategories(data.data);
  };
  const [focus, setFocused] = React.useState(false);
  const [focusTwo, setFocusedTwo] = React.useState(false);
  const [focusThree, setFocusedThree] = React.useState(false);
  const [focusFour, setFocusedFour] = React.useState(false);

  const [showStartingDate, setShowStartingDate] = React.useState(false);
  const [showEndingDate, setShowEndingDate] = React.useState(false);
  const [showRegistrationEndingDate, setShowRegistrationEndingDate] =
    React.useState(false);
  const [showBanner, setShowBanner] = React.useState(false);
  const [showDemoVideo, setShowDemoVideo] = React.useState(false);

  // let children = teacher.concat(damta);
  // //console.log(damta)

  // //console.log(subjects);
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setteacher(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  //delete
  const handleDelete = (id) => {
    setFileSelected([]);

    fileSelected?.map((item, index) => {
      if (item?.fileLoc !== id) {
        setFileSelected((prev) => [...prev, item]);
      }
    });
  };

  const onSubmit = async (data) => {
    setLoading(true);
    console.log("File ", file);
    const sanitizedSelectedTags = sanitizeTagList(autocompleteValue);
    const existingTagPayload = tags.reduce((acc, tag) => {
      const tagName = String(tag?.name || "").trim();
      if (!tagName) {
        return acc;
      }
      acc.push({
        name: tagName,
        status: sanitizedSelectedTags.includes(tagName),
      });
      return acc;
    }, []);
    const newTagPayload = sanitizedSelectedTags
      .filter(
        (name) => !tags.some((tag) => String(tag?.name || "").trim() === name)
      )
      .map((name) => ({
        name,
        status: true,
      }));

    const payload = {
      ...value,
      course_banner: url,
      demoVideo: selected || value?.demoVideo,
      subject: subjectList || value?.subject,
      teachers: teacher || value?.teachers,
      materials: materialsList.map((mat) => mat?.id),
      audioUrl: audioUrl,
      videoUrl: videoUrl,
      notesUrl: notesUrl,
      combo: comboChecked === "true" ? "true" : "false",
      testseries_id: testSeriesValue,
      registration_end_date: data?.registration_end_date,
      exam_groups_id: exam_groups_id,
      tags: [...existingTagPayload, ...newTagPayload],
    };
    console.log("payload--->>>>>>>>>>", payload);

    const token = localStorage.getItem("token");
    const authHeaders = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const tagsToUpdate = Object.entries(editedTags).reduce((acc, [id, name]) => {
      const trimmedName = String(name || "").trim();
      if (!trimmedName) {
        return acc;
      }
      const stillSelected = sanitizedSelectedTags.some(
        (selectedName) =>
          String(selectedName || "")
            .trim()
            .toLowerCase() === trimmedName.toLowerCase()
      );
      if (!stillSelected) {
        return acc;
      }
      acc.push({
        id,
        name: trimmedName,
      });
      return acc;
    }, []);

    const parsedCourseId = Number(batchId);
    const courseIdForPayload = Number.isNaN(parsedCourseId)
      ? batchId
      : parsedCourseId;

    if (tagsToUpdate.length) {
      try {
        await Promise.all(
          tagsToUpdate.map((tagInfo) =>
            axios.put(
              `${process.env.REACT_APP_LIVE_URL_NEW}/admin/update-tags?id=${tagInfo.id}`,
              {
                name: tagInfo.name,
                course_id: courseIdForPayload,
              },
              authHeaders
            )
          )
        );
        setEditedTags({});
      } catch (error) {
        console.error("Failed to update tags", error);
        toast.error("Failed to update tags");
        setLoading(false);
        return;
      }
    }

    axios
      .put(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/update-course/${batchId}`,
        payload,
        authHeaders
      )
      .then((response) => {
        console.log(response);
        if (response?.data?.response_code === 200) {
          reset();
          setLoading(false);
          toast.success(response?.data?.message);
          setTimeout(() => {
            navigate("/dashboard/batches");
          }, 1000);
        } else {
          toast.error(response?.data?.message);
          setLoading(false);
        }
      })
      .catch((e) => {
        //console.log(e);
        setLoading(false);
        toast.error(e.message);
      });
  };

  useEffect(() => {
    if (!showAudioField) {
      setAudioUrl("");
    }
    if (!showVideoField) {
      setVideoUrl("");
    }
    if (!showNotesField) {
      setNotesUrl("");
    }
    if (!showLiveField) {
      setSelected([]);
    }
  }, [showAudioField, showVideoField, showNotesField, showLiveField]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (comboChecked) {
      // Fetch Test Series details for Combo
      setLoadingTestSeries(true);
      axios
        .get(
          `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-testseries-by-goal?course=${parameter.course}&exam_id=${parameter.exam_id}&class_id=${parameter.class_id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          setTestSeriesOptions(response.data.data);
          console.log(response.data.data);
          setLoadingTestSeries(false);
        })
        .catch((error) => {
          console.error("Error fetching Test Series details:", error);
          setLoadingTestSeries(false);
        });
    }
  }, [comboChecked]);

  const handleChangeSubject = (event) => {
    const {
      target: { value },
    } = event;
    setsubjectList(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleChangeMaterials = (event, newVal) => {
    setMaterialsList(newVal);
  };

  const onChange2 = (e) => {
    // console.log(e);
    const { name, value } = e.target;
    setValue((prev) => ({ ...prev, [name]: value }));
  };

  // Debug useEffect for tagNames
  useEffect(() => {
    console.log("tagNames updated:", tagNames);
  }, [tagNames]);

  // Debug useEffect for tags
  useEffect(() => {
    console.log("tags updated:", tags);
  }, [tags]);

  // Ensure Autocomplete updates as soon as selected tag names arrive
  const [autocompleteValue, setAutocompleteValue] = useState([]);
  const [editingTagIndex, setEditingTagIndex] = useState(null);
  const [editingTagValue, setEditingTagValue] = useState("");
  const [editingTagId, setEditingTagId] = useState(null);
  const [editingOriginalLabel, setEditingOriginalLabel] = useState("");
  const [editedTags, setEditedTags] = useState({});

  const cancelTagEdit = () => {
    setEditingTagIndex(null);
    setEditingTagValue("");
    setEditingTagId(null);
    setEditingOriginalLabel("");
  };

  const handleTagEditStart = (index, label) => {
    setEditingTagIndex(index);
    setEditingTagValue(label);
    setEditingOriginalLabel(label);

    const matchedTag = Array.isArray(tags)
      ? tags.find(
          (tag) =>
            Number(tag?.active) === 1 &&
            String(tag?.name || "")
              .trim()
              .toLowerCase() === String(label || "").trim().toLowerCase()
        )
      : null;

    setEditingTagId(matchedTag?.id ?? null);
  };

  const commitTagEdit = (index) => {
    const trimmedValue = String(editingTagValue || "").trim();
    if (!trimmedValue) {
      cancelTagEdit();
      return;
    }

    const sanitizedValue = sanitizeTagList([trimmedValue])[0] || trimmedValue;

    setAutocompleteValue((prev) => {
      const next = [...prev];
      next[index] = sanitizedValue;
      return sanitizeTagList(next);
    });

    setTagNames((prev) => {
      const next = [...prev];
      next[index] = sanitizedValue;
      return sanitizeTagList(next);
    });

    if (editingTagId) {
      const originalLabel = String(editingOriginalLabel || "").trim();
      if (
        originalLabel.length &&
        originalLabel.toLowerCase() !== sanitizedValue.toLowerCase()
      ) {
        setEditedTags((prev) => ({
          ...prev,
          [editingTagId]: sanitizedValue,
        }));
      } else {
        setEditedTags((prev) => {
          if (!prev[editingTagId]) {
            return prev;
          }
          const next = { ...prev };
          delete next[editingTagId];
          return next;
        });
      }
    }

    cancelTagEdit();
  };

  const handleTagEditKeyDown = (event, index) => {
    if (event.key === "Enter") {
      event.preventDefault();
      commitTagEdit(index);
    } else if (event.key === "Escape") {
      event.preventDefault();
      cancelTagEdit();
    }
  };
  useEffect(() => {
    if (Array.isArray(tagNames) && tagNames.length > 0) {
      // populate autocomplete value immediately so chips render even if options load later
      setAutocompleteValue(sanitizeTagList(tagNames));
    } else {
      setAutocompleteValue([]);
    }
    cancelTagEdit();
  }, [tagNames]);

  return (
    <>
      <Page title="Courses">
        <Stack spacing={3} ml={5}>
          <Typography className="page-heading">Update Course </Typography>
          {batchDetails ? (
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
              <Stack spacing={3} sx={{ width: "80%" }}>
                <RHFTextField
                  name="name"
                  value={value?.name}
                  onChange={onChange2}
                />
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ my: 2 }}
                  spacing={2}
                ></Stack>

                <Stack direction="row" spacing={3}>
                  <Stack sx={{ width: "50%" }}>
                    <FormControl>
                      <InputLabel>Subject</InputLabel>
                      <Select
                        label="Subject"
                        multiple
                        name="subject"
                        value={subjectList}
                        onChange={handleChangeSubject}
                        sx={{ width: "100%", color: "black", zIndex: 9 }}
                        MenuProps={MenuProps}
                      >
                        {subject?.map((sub, index) => (
                          <MenuItem
                            key={sub?.id}
                            value={sub?.id}
                            style={getStyles(sub?.name, subject, theme)}
                          >
                            {sub?.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Stack>
                  <Stack sx={{ width: "50%" }}>
                    <FormControl>
                      <InputLabel>Teacher</InputLabel>
                      <Select
                        label="Teacher"
                        multiple
                        name="teacher"
                        value={teacher}
                        onChange={handleChange}
                        sx={{ width: "100%", color: "black", zIndex: 9 }}
                        MenuProps={MenuProps}
                      >
                        {allteachers?.map((name, index) => {
                          return (
                            <MenuItem
                              key={name}
                              value={name?.id}
                              style={getStyles(name, teacher, theme)}
                            >
                              {name?.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Stack>
                </Stack>

                <Stack direction={"row"} spacing={3}>
                  <RHFTextField
                    name="category"
                    label="Category"
                    disabled
                    sx={{ width: "50%" }}
                    // select
                    value={category}
                    // onChange={handleCategoryChange}
                  />

                  {states && (
                    <RHFTextField
                      name="states"
                      label="State"
                      disabled
                      sx={{ width: "50%" }}
                      // select
                      value={states}
                      // onChange={handleStateChange}
                    />
                  )}

                  {boards && (
                    <RHFTextField
                      name="boards"
                      label="Boards"
                      disabled
                      sx={{ width: "50%" }}
                      // select
                      value={boards}
                      // onChange={handleBoardChange}
                    />
                  )}

                  <RHFTextField
                    name="subCategory"
                    label="Subcategory"
                    disabled
                    sx={{ width: "50%" }}
                    value={stateExam || classVal}
                    // select
                    // onChange={handleSubCategoryChange}
                  />
                </Stack>
                <RHFTextField
                  name="exam_groups_id"
                  label="Exam groups"
                  sx={{ width: "50%" }}
                  select
                  value={exam_groups_id}
                  onChange={changeGroupHandler}
                >
                  {groups?.map((board, index) => (
                    <MenuItem key={index} value={board.id}>
                      {board.name}
                    </MenuItem>
                  ))}
                </RHFTextField>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ my: 2 }}
                  spacing={2}
                >
                  {/* <RHFTextField
                    name="starting_date"
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    InputProps={{
                      classes: {
                        input: "CustomTextField",
                      },
                    }}
                    label={`${value?.starting_date?.split(" ")[0]
                      } (Starting Date)`}
                    onClick={() => setShowStartingDate(true)}
                    type={showStartingDate || focus ? "date" : "text"}
                  />
                  <RHFTextField
                    name="ending_date"
                    onFocus={() => setFocusedTwo(true)}
                    onBlur={() => setFocusedTwo(false)}
                    InputProps={{
                      classes: {
                        input: "CustomTextField",
                      },
                    }}
                    label={`${value?.ending_date
                      ? value.ending_date.split(" ")[0]
                      : "N/A"
                      } (Ending Date)`}
                    onClick={() => setShowEndingDate(true)}
                    type={showEndingDate || focusTwo ? "date" : "text"}
                  />
                  <RHFTextField
                    name="registration_end_date"
                    onFocus={() => setFocusedFour(true)}
                    onBlur={() => setFocusedFour(false)}
                    InputProps={{
                      classes: {
                        input: "CustomTextField",
                      },
                    }}
                    label={`${value?.registration_end_date?.split(" ")[0]
                      } (Registration Ending Date)`}
                    onClick={() => setShowRegistrationEndingDate(true)}
                    type={
                      showRegistrationEndingDate || focusFour ? "date" : "text"
                    }
                  /> */}

                <Stack direction="column" sx={{ width: "100%" }}>
                  <Autocomplete
                    multiple
                    id="materials-outlined"
                    name="materials"
                    options={materialsOptions}
                    value={materialsList}
                    onChange={handleChangeMaterials}
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Course Type"
                        placeholder="Select course materials"
                        value={materialsList}
                      />
                    )}
                    required
                  />

                  {materialsList.length == 0 && (
                    <Typography
                      sx={{
                        fontSize: "12px",
                        marginTop: "5px",
                        marginLeft: "10px",
                        color: "red",
                      }}
                    >
                      Course Type is required!
                    </Typography>
                  )}
                </Stack>
                </Stack>

                {/* Material URLs */}
                {(showAudioField || showVideoField || showNotesField) && (
                  <Stack direction="row" spacing={3} sx={{ my: 2 }}>
                    {showAudioField && (
                      <Stack sx={{ flex: 1 }}>
                        <Typography sx={{ mb: 1 }}>Audio (MP3)</Typography>
                        <input
                          accept="audio/*"
                          type="file"
                          onChange={handleAudioUpload}
                          style={{ width: "100%" }}
                        />
                        {audioUrl && (
                          <Typography
                            sx={{ fontSize: 12, mt: 1, wordBreak: "break-all" }}
                          >
                            Uploaded: {audioUrl}
                          </Typography>
                        )}
                      </Stack>
                    )}

                    {showVideoField && (
                      <Stack sx={{ flex: 1 }}>
                        <TextField
                          label="Video URL"
                          value={videoUrl}
                          onChange={(e) => setVideoUrl(e.target.value)}
                          placeholder="Enter video URL (YouTube or embed link)"
                          sx={{ width: "100%" }}
                        />
                      </Stack>
                    )}

                    {showNotesField && (
                      <Stack sx={{ flex: 1 }}>
                        <Typography sx={{ mb: 1 }}>Notes (PDF)</Typography>
                        <input
                          accept="application/pdf"
                          type="file"
                          onChange={handleNotesUpload}
                          style={{ width: "100%" }}
                        />
                        {notesUrl && (
                          <Typography
                            sx={{ fontSize: 12, mt: 1, wordBreak: "break-all" }}
                          >
                            Uploaded: {notesUrl}
                          </Typography>
                        )}
                      </Stack>
                    )}
                  </Stack>
                )}

                <Stack
                  direction="row"
                  alignItems="flex-start" // Change to flex-start to align inputs at the top
                  justifyContent="space-between"
                  sx={{ my: 2 }}
                  spacing={2}
                >
                  <RHFTextField
                    name="charges"
                    label="Charges"
                    value={Number(value?.charges)}
                    onChange={onChange2}
                    type="number"
                    sx={{ minHeight: "72px" }} // Ensure the same height to align with helperText
                  />
                  <RHFTextField
                    name="discount"
                    label="Discount"
                    value={Number(value?.discount)}
                    onChange={onChange2}
                    type="number"
                    sx={{ minHeight: "72px" }} // Same height as above
                  />
                  <RHFTextField
                    name="validity"
                    label="Validity (in days)"
                    value={Number(value?.validity)}
                    onChange={onChange2}
                    type="number"
                    sx={{ minHeight: "72px" }} // Same height as above
                  />

                  {/* <RHFTextField
                  name="bannerfileType"
                  label={batchDetails?.banner[0]?.bannerfileType}
                  select
                >
                  <MenuItem value="image">Image</MenuItem>
                  <MenuItem value="video">Video</MenuItem>
                </RHFTextField> */}
                  <RHFTextField
                    name="banner"
                    onChange={changeHandler}
                    onFocus={() => setFocusedThree(true)}
                    onBlur={() => setFocusedThree(false)}
                    helperText="Image with a size of 712x356 pixels, maintaining a 2:1 aspect ratio (jpeg,jpg,png,webp)"
                    InputProps={{
                      classes: {
                        input: "CustomTextField",
                      },
                    }}
                    label="Banner"
                    onClick={() => setShowBanner(true)}
                    type={showBanner || focusThree ? "file" : "text"}
                    sx={{
                      marginBottom: "-8px", // Adjust margin to align helper text better
                    }}
                    FormHelperTextProps={{
                      sx: {
                        marginTop: "4px", // Reduce space between input and helper text
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                  />
                </Stack>
                {showLiveField && (
                  <Stack>
                    <TagsInput
                      value={selected}
                      onChange={setSelected}
                      name="link"
                      placeHolder="Enter Youtube Links"
                      className="rti--input"
                    />
                  </Stack>
                )}
                {/* {console.log(value?.language)} */}
                <RHFTextField
                  name="language"
                  label={"Language"}
                  disabled
                  value={value?.language}
                  onChange={onChange2}
                  sx={{ width: "100%" }}
                  select
                >
                  {languages?.map((language, index) => (
                    <MenuItem key={index} value={language?.medium_code}>
                      {language?.medium_name}
                    </MenuItem>
                  ))}

                  <MenuItem key="both" value={3}>
                    Both
                  </MenuItem>
                </RHFTextField>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ my: 2 }}
                  spacing={2}
                >
                  {/* <RHFTextField
                    name="remark"
                    // label="Remarks"
                    value={value?.remark}
                    onChange={onChange2}
                    type="text"
                  /> */}
                  <RHFTextField
                    name="is_active"
                    label={value?.is_active === "true" ? "Published" : "Draft"}
                    value={value?.is_active}
                    sx={{ width: "100%" }}
                    select
                    onChange={onChange2}
                    // type="checkbox"
                  >
                    <MenuItem
                      value={"true"}
                      // onClick={() => setIsActive("true")}
                    >
                      Publish
                    </MenuItem>
                    <MenuItem
                      value={"false"}
                      // onClick={() => setIsActive("false")}
                    >
                      Draft
                    </MenuItem>
                  </RHFTextField>
                </Stack>

                {/* <Stack>
                  {tags.map((tag, index) => (
                    <div key={index} style={{ display: 'inline-flex', margin: '5px' }}>
                      {editingIndex === index ? (
                        <input
                          type="text"
                          value={editValue}
                          onChange={handleEditChange}
                          onBlur={() => handleEditSave(index)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') handleEditSave(index);
                          }}
                          autoFocus
                        />
                      ) : (
                        <span
                          style={{ padding: '5px', border: '1px solid #ccc', cursor: 'pointer' }}
                          onClick={() => handleEditStart(index)}
                        >
                          {tag}
                        </span>
                      )}
                    </div>
                  ))}
                </Stack> */}
                <Stack direction="column" sx={{ width: "100%" }}>
                  <Autocomplete
                    multiple
                    freeSolo
                    id="tags-autocomplete"
                    name="tags"
                    // deduplicate option names in case API returns duplicates
                    options={sanitizeTagList(
                      tags
                        .filter((t) => Number(t.active) === 0)
                        .map((t) => t.name)
                    )}
                    value={autocompleteValue}
                    onChange={(event, newValue) => {
                      const sanitized = sanitizeTagList(newValue || []);
                      setAutocompleteValue(sanitized);
                      setTagNames(sanitized);
                      cancelTagEdit();
                      setEditedTags((prev) => {
                        if (!prev || !Object.keys(prev).length) {
                          return prev;
                        }
                        const selectedLookup = new Set(
                          sanitized.map((name) =>
                            String(name || "").trim().toLowerCase()
                          )
                        );
                        const next = Object.entries(prev).reduce(
                          (acc, [id, name]) => {
                            if (
                              selectedLookup.has(
                                String(name || "").trim().toLowerCase()
                              )
                            ) {
                              acc[id] = name;
                            }
                            return acc;
                          },
                          {}
                        );
                        return next;
                      });
                    }}
                    // ensures option/value matching even if option objects/strings arrive at different times
                    isOptionEqualToValue={(option, value) =>
                      String(option).trim() === String(value).trim()
                    }
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => {
                        const tagProps = getTagProps({ index });
                        const { key, ...chipProps } = tagProps;

                        if (editingTagIndex === index) {
                          return (
                            <Box
                              key={key}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mr: 1,
                                mb: 0.5,
                              }}
                            >
                              <TextField
                                value={editingTagValue}
                                onChange={(event) =>
                                  setEditingTagValue(event.target.value)
                                }
                                onBlur={() => commitTagEdit(index)}
                                onKeyDown={(event) =>
                                  handleTagEditKeyDown(event, index)
                                }
                                size="small"
                                autoFocus
                                sx={{ minWidth: 100 }}
                              />
                            </Box>
                          );
                        }

                        return (
                          <Chip
                            {...chipProps}
                            key={key}
                            label={option}
                            onDoubleClick={() =>
                              handleTagEditStart(index, option)
                            }
                          />
                        );
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Tags"
                        placeholder="Select existing tags or type to create new ones"
                      />
                    )}
                    filterSelectedOptions
                  />

                  {autocompleteValue.length === 0 && tags.length > 0 && (
                    <Typography
                      sx={{
                        fontSize: "12px",
                        marginTop: "5px",
                        marginLeft: "10px",
                        color: "red",
                      }}
                    >
                      {"Tags are required!"}
                    </Typography>
                  )}
                </Stack>

                <RHFTextEditor
                  name="description"
                  value={value?.description}
                  label={"Description"}
                  onChange={(value) => {
                    setValue((prev) => ({ ...prev, description: value }));
                  }}
                />
              </Stack>

              <LoadingButton
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                // onSubmit={handleSubmit(onSubmit)}
                loading={loading}
                sx={{
                  bgcolor: "#e6e6ff",
                  color: "black",
                  width: "80%",

                  marginTop: "5%",
                  "&:hover": { background: " #8080ff" },
                }}
              >
                Update
              </LoadingButton>
            </FormProvider>
          ) : (
            <div
              sx={{ width: "full", justifyContent: "center", display: "flex" }}
            >
              <CircularProgress sx={{ display: "flex" }} />
            </div>
          )}
          <ToastContainer
            position="bottom-center"
            autoClose={1000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          {/* <Typography color={positive ? 'green' : "red"} sx={{ textAlign: 'center', textTransform: 'capitalize' }}>{fetchMessage}</Typography> */}
        </Stack>
      </Page>
    </>
  );
};

export default UpdateBatchDetails;
